function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import ImagesGrid from "segments/desktop/core-components/images-grid/images-grid";
import { ALIGN_TYPES } from "constants/align-types";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
import { SM } from "constants/sizes";
import { StyledMultiTemplatesTemplatesComponent } from "./multi-templates-templates-component.scss";
import { getFullParagraph, getImageSrcAndAlt } from "../utils";
const MultiTemplatesTemplatesComponent = (props)=>{
    const { mobileTextAlign, solutionsInfo, imagePosition, textAlign, titleSize, textSize, dynamicProps: { solutions = [] } = {} } = props;
    const getSolutions = ()=>{
        return solutionsInfo.map(({ overrideTitle, overrideDescription, overrideImage = {}, topicText, buttonSelect, solutionId, showTitle, showDescription, showImageShadow })=>{
            const fetchSolution = solutions.find((solution)=>{
                return solutionId === (solution === null || solution === void 0 ? void 0 : solution.id);
            }) || {};
            const { data: { name: title, description, images } = {} } = fetchSolution;
            return _object_spread_props(_object_spread({}, getImageSrcAndAlt({
                images,
                overrideImage
            })), {
                shadow: showImageShadow,
                fullParagraph: getFullParagraph({
                    title,
                    description,
                    overrideTitle,
                    overrideDescription,
                    topicText,
                    buttonSelect,
                    solutionId,
                    showTitle,
                    showDescription,
                    textAlign,
                    mobileTextAlign
                })
            });
        });
    };
    return /*#__PURE__*/ _jsx(StyledMultiTemplatesTemplatesComponent, {
        className: "multi-templates-templates-component",
        children: /*#__PURE__*/ _jsx(ImagesGrid, {
            images: getSolutions(solutionsInfo, solutions),
            isWithParagraph: true,
            imagePosition: imagePosition,
            textAlign: textAlign,
            titleSize: titleSize,
            textSize: textSize,
            numberOfCardsInRow: 3,
            fitHeightToImgHeight: true
        })
    });
};
MultiTemplatesTemplatesComponent.defaultProps = {
    solutionsInfo: [],
    paddingTop: "56px",
    paddingBottom: "56px",
    imagePosition: positionTypes.CENTER_CENTER,
    textAlign: ALIGN_TYPES.LEFT,
    titleSize: SM,
    textSize: SM
};
export default MultiTemplatesTemplatesComponent;
